// ** React Import
import { useEffect } from 'react'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Third Party Import
import { useTranslation } from 'react-i18next'

// ** Custom Components Imports
import OptionsMenu from 'src/@core/components/option-menu'

// ** Type Import
import { Settings } from 'src/@core/context/settingsContext'

interface Props {
  settings: Settings
  saveSettings: (values: Settings) => void
}

enum Language {
  SPANISH = 'es',
  ENGLISH = 'en',
  PORTUGUESE = 'pt'
}

const LanguageDropdown = ({ settings, saveSettings }: Props) => {
  // ** Hook
  const { t, i18n } = useTranslation()

  // ** Vars
  const { layout } = settings

  const handleLangItemClick = (lang: Language.SPANISH | Language.ENGLISH | Language.PORTUGUESE) => {
    i18n.changeLanguage(lang).then()
  }

  // ** Change html `lang` attribute when changing locale
  useEffect(() => {
    document.documentElement.setAttribute('lang', i18n.language)
  }, [i18n.language])

  return (
    <OptionsMenu
      icon={<Icon icon='mdi:translate' />}
      menuProps={{ sx: { '& .MuiMenu-paper': { mt: 4, minWidth: 130 } } }}
      iconButtonProps={{ color: 'inherit', sx: { ...(layout === 'vertical' ? { mr: 0.75 } : { mx: 0.75 }) } }}
      options={[
        {
          text: t('Espanol'),
          menuItemProps: {
            sx: { py: 2 },
            selected: i18n.language === Language.SPANISH,
            onClick: () => {
              handleLangItemClick(Language.SPANISH)
              saveSettings({ ...settings, direction: 'ltr' })
            }
          }
        },
        {
          text: t('Ingles'),
          menuItemProps: {
            sx: { py: 2 },
            selected: i18n.language === Language.ENGLISH,
            onClick: () => {
              handleLangItemClick(Language.ENGLISH)
              saveSettings({ ...settings, direction: 'ltr' })
            }
          }
        },
        {
          text: t('Portugues'),
          menuItemProps: {
            sx: { py: 2 },
            selected: i18n.language === Language.PORTUGUESE,
            onClick: () => {
              handleLangItemClick(Language.PORTUGUESE)
              saveSettings({ ...settings, direction: 'ltr' })
            }
          }
        }
      ]}
    />
  )
}

export default LanguageDropdown
